module.exports = __webpack_public_path__ + "static/img/1.ab85e25.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/9/zh/1.png
// module id = drTU
// module chunks = 0